import { getFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import classNames from 'classnames/bind';
import withStyles from 'lib/enhancers/withStyles';
import compose from 'lib/enhancers/compose';
import styles from './ShowDetail.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import ShowSummaryWithLinks from './ShowSummaryWithLinks';

import type { RecordOfFields } from 'models/fields';
import type { ShowDetailProps } from 'models/podcasts-types';
import SeasonEpisodes from './SeasonEpisodes';
import Hosts from './Hosts';
import ShowSeasons from './ShowSeasons';

const ShowDetail = (props: ShowDetailProps): React.JSX.Element => {
  const cx = classNames.bind(styles);

  const { className, fields } = props;
  const { description, highlightVideoKalturaMediaId, showDetails, seasons, episodes } = fields;

  const titleHeadingLevelItemField = fields.titleHeadingLevel?.fields as RecordOfFields;
  const titleHeadingLevelValue = getFieldValue<string>(titleHeadingLevelItemField, 'Value') || 'h2';
  const titleTextStyleItemField = fields.titleTextStyle?.fields as RecordOfFields;
  const titleTextStyleValue = getFieldValue<string>(titleTextStyleItemField, 'Value') || 'font-style-xl';

  const kalturaCode = highlightVideoKalturaMediaId.value;

  const kalturaPlayerTypeItemField = fields.highlightVideoKalturaPlayerType?.fields as RecordOfFields;
  const kalturaPlayerTypeValue = getFieldValue<string>(kalturaPlayerTypeItemField, 'playerID') || '55870672';

  const playerId = 'video_id_' + kalturaCode;

  if (typeof window !== 'undefined' && kalturaCode) {
    const scriptk = document.createElement('script');

    scriptk.src =
      'https://cdnapisec.kaltura.com/p/6105852/embedPlaykitJs/uiconf_id/' +
      kalturaPlayerTypeValue +
      '?autoembed=true&targetId=' +
      playerId +
      '&entry_id=' +
      kalturaCode;

    scriptk.type = 'text/javascript';
    scriptk.async = true;
    if (!document.querySelector(`script[src="${scriptk.src}"]`)) {
      document.body.appendChild(scriptk);
    }
  }

  return (
    <div className={cx('podcasts-season-details', className)}>
      <div className={cx('podcasts-show-synopsis', className)}>
        {kalturaCode != '' && (
          <div className={cx('responsive_padding', 'video-padding', className)}>
            <div className={cx('responsive_wrapper', 'video-wrapper')}>
              <div id={playerId} style={{ width: '100%', height: 'auto', aspectRatio: '16 / 9' }}></div>
            </div>
          </div>
        )}
        <RichTextWrapper field={description} />
        <ShowSummaryWithLinks showDetails={showDetails} />
      </div>

      {seasons && seasons.length > 0 && (
        <ShowSeasons
          seasons={seasons}
          seasonsFallbackImage={showDetails.fallbackImage}
          titleHeadingLevel={titleHeadingLevelValue}
          titleTextStyle={titleTextStyleValue}
        />
      )}

      {episodes && episodes.length > 0 && (
        <SeasonEpisodes
          episodes={episodes}
          episodesFallbackImage={showDetails.fallbackImage}
          titleHeadingLevel={titleHeadingLevelValue}
          titleTextStyle={titleTextStyleValue}
        />
      )}

      <Hosts hosts={showDetails.hosts} personFallbackImage={showDetails.personFallbackImage} />
    </div>
  );
};

export default compose<ShowDetailProps>(withStyles())(ShowDetail);
